export var tableRow = function tableRow(content) {
  return {
    type: 'tableRow',
    content: content
  };
};